import { Location } from '@angular/common';
import { OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssessmentService } from "../../shared/services/assessment.service";
import { DacConfig } from 'app/shared/services/dac-config.service';
var AssessmentResultViewComponent = /** @class */ (function () {
    function AssessmentResultViewComponent(route, router, _assessmentService, location, elementRef, dacConfig) {
        this.route = route;
        this.router = router;
        this._assessmentService = _assessmentService;
        this.location = location;
        this.elementRef = elementRef;
        this.dacConfig = dacConfig;
        this._visibleScaleResults = [];
    }
    AssessmentResultViewComponent.prototype.showCommandButtons = function () {
        return !this.dacConfig.seamlessMode;
    };
    AssessmentResultViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.queryParamsSubscription = this.route.queryParams.subscribe(function (params) {
            if (params['notes'] && params['notes'] == '1') {
                _this.displayTherapistNotes = true;
            }
            else {
                _this.displayTherapistNotes = false;
            }
        });
        // TODO: stephen do we need the rx switchTo piece?
        this.route.params.subscribe(function (params) {
            _this._clientId = params['id'];
            var resultId = params['resultId'];
            _this.hasLoadedResults = false;
            _this._assessmentService.getAssessmentResult(_this._clientId, resultId).then(function (result) {
                _this.hasLoadedResults = true;
                _this.result = result;
                if (_this.result == null || !_this.result.scaleResults || _this.result.scaleResults.length < 1) {
                    // this.goBack();
                }
                else {
                    _this._visibleScaleResults = _this.result.scaleResults.filter(function (sr) { return sr.scale && sr.scale.includeInReports === true; });
                }
            })
                .catch(function (error) {
                console.error(error);
                if (error && error.status === 404 || error.status === 400) {
                    // this.goBack();
                }
            });
        });
    };
    AssessmentResultViewComponent.prototype.ngAfterViewInit = function () {
        // we need to let outside listeners like the server pdf generator know we have finished loading so we can generate the report
        console.log("adding dac-report-loaded class");
        document.body.classList.add("dac-report-loaded");
    };
    AssessmentResultViewComponent.prototype.ngAfterContentInit = function () {
    };
    Object.defineProperty(AssessmentResultViewComponent.prototype, "scaleResults", {
        get: function () {
            return this._visibleScaleResults;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentResultViewComponent.prototype.goBack = function () {
        this.location.back();
    };
    Object.defineProperty(AssessmentResultViewComponent.prototype, "clientID", {
        get: function () {
            return this._clientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssessmentResultViewComponent.prototype, "result", {
        get: function () {
            return this._result;
        },
        set: function (v) {
            this._result = v;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentResultViewComponent.prototype.print = function () {
        this.showPrintDialog = true;
    };
    AssessmentResultViewComponent.prototype.closePrintDialog = function () {
        // reset it once we've closed the dialog.
        this.showPrintDialog = false;
    };
    return AssessmentResultViewComponent;
}());
export { AssessmentResultViewComponent };



// WEBPACK FOOTER //
// ./src/app/reports/assessment-result-view/assessment-result-view.component.ts.pre-build-optimizer.js